import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RegelmotorInput } from '../../berakningshjalpen/shared/models/regelmotorInput.model';
import { Inkomsttyp } from '../../berakningshjalpen/shared/enums/inkomsttyp.enum';
import { InfotexterInput } from '../../berakningshjalpen/shared/models/infotexterInput.model';

@Injectable({
  providedIn: 'root'
})
export class RegelmotorService {

  readonly baseUrl: string = (window as any).env.serverPath;

  constructor(private readonly httpClient: HttpClient) {
  }

  getValutor(): PromiseLike<any> {
    return this.httpClient
      .get(this.baseUrl + '/regelmotor/valutor')
      .toPromise();

  }

  getLander(inkomsttyp: Inkomsttyp): PromiseLike<any> {
    const params = new HttpParams()
      .set('inkomsttyp', inkomsttyp);
    return this.httpClient
      .get(this.baseUrl + '/regelmotor/lander', {params})
      .toPromise();
  }

  getInfotexter(infotexterInput: InfotexterInput): PromiseLike<any> {
    return this.httpClient
      .post<InfotexterInput>(this.baseUrl + '/regelmotor/infotexter', infotexterInput)
      .toPromise();
  }

  getResultat(regelmotorInput: RegelmotorInput) {
    return this.httpClient.post(this.baseUrl + '/regelmotor/skatteberakning', regelmotorInput)
      .toPromise();
  }
}
